import { createAction } from '@ngrx/store';

import { CustomSuggestTerm } from 'ish-core/models/suggest-term/custom-suggest-term.model';
import { payload } from 'ish-core/utils/ngrx-creators';

export const customSuggestSearch = createAction(
  '[Suggest Search Internal] Load ICSA Search Suggestions',
  payload<{ searchTerm: string }>()
);

export const customSuggestSearchSuccess = createAction(
  '[Suggest Search API] Return ICSA Search Suggestions',
  payload<{ searchTerm: string; suggests: CustomSuggestTerm[] }>()
);
